// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"DingBeautySectionTitle_sectionTitle_VEjGn"};